import {
    faStars,
    faHandsHoldingChild,
    faRocket,
    faIdCardClip,
    faBadgePercent,
    faCartArrowDown,
    faPersonWalkingArrowLoopLeft,
    faBirthdayCake,
    faBallotCheck,
    faMessagesQuestion,
    faFaceSmilePlus,
    faScrewdriverWrench,
    faSquareDashed,
} from '@fortawesome/pro-solid-svg-icons';

export const CATEGORIES = [
    {
        label: 'Birthday',
        value: 'birthday',
        icon: faBirthdayCake,
        description: 'Messages celebrating a customer’s birthday, often with a special offer or greeting.',
    },
    {
        label: 'Charity',
        value: 'charity',
        icon: faHandsHoldingChild,
        description: 'Messages encouraging donations, participation, or support for a charitable cause or non-profit.',
    },
    {
        label: 'Cross Sell/Upsell',
        value: 'cross_sell',
        icon: faCartArrowDown,
        description:
            'Messages recommending an additional or upgraded product or service to complement a previous purchase.',
    },
    {
        label: 'Lead Engagement',
        value: 'lead_engagement',
        icon: faMessagesQuestion,
        description: 'Messages designed to convert potential customers into first-time buyers.',
    },
    {
        label: 'Loyalty Program',
        value: 'loyalty_program',
        icon: faBadgePercent,
        description:
            'Messages encouraging sign-ups for a loyalty or rewards program, or updating customers on their rewards status.',
    },
    {
        label: 'Membership',
        value: 'membership',
        icon: faIdCardClip,
        description: 'Messages promoting the purchase or renewal of a membership program.',
    },
    {
        label: 'Offer',
        value: 'offer',
        icon: faStars,
        description: 'Messages promoting a sale, discount, or special pricing on a product or service.',
    },
    {
        label: 'Operational',
        value: 'operational',
        icon: faScrewdriverWrench,
        description:
            'Transactional messages providing important updates or reminders, without a promotional call-to-action.',
    },
    {
        label: 'Product Update/Release',
        value: 'product_update',
        icon: faRocket,
        description: 'Messages informing customers about a new or updated product or service.',
    },
    {
        label: 'Survey',
        value: 'survey',
        icon: faBallotCheck,
        description: 'Messages requesting customer feedback or responses to specific questions.',
    },
    {
        label: 'Uncategorized',
        value: null,
        icon: faSquareDashed,
        description: 'These are messages that are not categorized.',
    },
    {
        label: 'Uncategorized',
        value: 'none',
        icon: faSquareDashed,
        description: 'These are messages that are not categorized.',
    },
    {
        label: 'Welcome/Enrollment',
        value: 'welcome',
        icon: faFaceSmilePlus,
        description: 'Messages welcoming new customers or confirming their enrollment in a program.',
    },
    {
        label: 'Winback',
        value: 'winback',
        icon: faPersonWalkingArrowLoopLeft,
        description: "Messages aimed at re-engaging past customers who haven't made a purchase in a while.",
    },
];

export type Category =
    | 'birthday'
    | 'charity'
    | 'cross_sell'
    | 'lead_engagement'
    | 'loyalty_program'
    | 'membership'
    | 'offer'
    | 'operational'
    | 'product_update'
    | 'survey'
    | 'none'
    | 'welcome'
    | 'winback'
    | null;

export type AnalyticsCategory = Exclude<Category, null>;
export type ResourceCategory = Exclude<Category, 'none'>;

export const analyticsCategoriesOptions = CATEGORIES.filter((category) => category.value !== null);
export const resourceCategoriesOptions = CATEGORIES.filter((category) => category.value !== 'none');
export const analyticsCategoriesValues = analyticsCategoriesOptions.map((category) => category.value);
export const getCategoryByValue = (value: Category) => CATEGORIES.find((category) => category.value === value);
export const getCategoryLabel = (value: Category) => CATEGORIES.find((category) => category.value === value)?.label;
